import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function ChevronLeft(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M6 12C6 12.2653 6.10726 12.4912 6.30104 12.6907L15.6685 21.7233C15.8426 21.9078 16.0789 22 16.3452 22C16.8743 22 17.2836 21.6 17.2836 21.0616C17.2836 20.7999 17.181 20.574 17.0116 20.3941L8.31264 12L17.0116 3.60584C17.181 3.42605 17.2836 3.18975 17.2836 2.93843C17.2836 2.40004 16.8743 2 16.3452 2C16.0789 2 15.8426 2.09223 15.6685 2.2767L6.30104 11.3093C6.10726 11.5088 6 11.7347 6 12Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
